<template>
  <div class="wrap-box">
    <!-- 催单次数 -->
    <van-notify
      color="#F32222"
      background="#FFDDDD"
      v-model="showRemainderNotify"
    >
      <span>已催单{{ taskDetail.remainderCount }}次</span>
    </van-notify>
    <div class="top-box">
      <div
        class="header-notify-box"
        v-if="showWorkerNotify"
      >
        <img
          class="img-icon"
          src="@/assets/img/orderGeneral/warningIcon@2x.png"
        >
        <span>注意拖车起点是否合规并报备，否则0结</span>
      </div>
      <div
        class="content-box"
        :style="{ 'padding-top': showRemainderNotify ? '36px' : '0' }"
      >
        <!-- 订单信息 -->
        <div class="car-info-box card-padding">
          <div class="order-no-item">
            <div class="order-no-item-left">
              <span
                class="order-company"
                v-if="isShowOrderCompany"
              >
                {{ orderCompanyText }}&nbsp;&nbsp;|&nbsp;&nbsp;
              </span>
              <span
                class="car-no order-no"
                :class="{
                  'color-red': taskDetail.vipCompany === '1',
                  'order-svip': isZvVipAndVipCompany,
                }"
              >{{ taskDetail.orderNo || "-" }}</span>
              <div
                class="zv-vip-icon"
                v-if="isShowZvVip"
              >至尊VIP</div>
              <div
                class="zv-vip-icon"
                v-if="isShowBcCustomer"
              >黑钻客户</div>
              <img
                v-if="taskDetail.vipCompany === '1'"
                src="@/assets/img/orderGeneral/vipCompany.png"
                class="vip-icon"
              >
              <!-- 平安聚合 -->
              <img
                v-if="
                  (taskDetail.otherTags || []).includes('DISPATCH_POLYMERIZE')
                "
                src="@/assets/img/orderGeneral/paicPolymerize.png"
                class="paic-icon"
              >
              <!-- 中华聚合 -->
              <img
                v-if="
                  (taskDetail.otherTags || []).includes(
                    'DISPATCH_POLYMERIZA_CICP'
                  )
                "
                src="@/assets/img/orderGeneral/cicpPolymerize.png"
                class="cicp-icon"
              >
              <!-- 直派 -->
              <img
                v-if="
                  (taskDetail.otherTags || []).includes(
                    'DISPATCH_CIAS_POLYMERIZE'
                  )
                "
                src="@/assets/img/orderGeneral/dispachPolymerize.png"
                class="dispatch-icon"
              >
              <!-- <div>
                <div
                  class="order-polymerize"
                  v-if="taskDetail.workOrderType === 1"
                >聚合</div>
              </div> -->
            </div>
            <div>
              <div
                class="copy-btn"
                @click="copy($event, copyText)"
              >复制</div>
            </div>
          </div>
        </div>
        <div class="car-info-box card-box card-padding">
          <div class="car-info-item">
            <span>服务项目：</span>
            <div>
              <span class="car-no">{{ taskDetail.productSkuName || "-" }}</span>
              <van-tag
                color="#FFF0EA"
                text-color="#C78062"
                v-if="taskDetail.appointmentTime"
              >{{
                taskDetail.appointmentTime.includes("实时") ? "实时" : "预约"
              }}</van-tag>
              <van-tag
                color="#FFF0EA"
                text-color="#C78062"
                v-if="taskDetail.appOrderPayType"
              >{{ taskDetail.appOrderPayType }}</van-tag>
            </div>
          </div>
          <div class="car-info-item">
            <span>车牌号码：</span>
            <span class="car-no">{{ taskDetail.carNo || "-" }}</span>
            <span
              class="copy-btn"
              @click="copy($event, taskDetail.carNo)"
            >复制</span>
          </div>
          <div class="car-info-item">
            <span>车架号码：</span>
            <span class="car-no">{{ taskDetail.vinNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>联系人：</span>
            <span class="car-no">{{ taskDetail.contactName || "-" }}</span>
            <span
              class="order-tag"
              v-if="taskDetail.vipCompany === '1'"
            >VIP</span>
            <template v-if="taskDetail.tagCodes">
              <span
                class="order-tag"
                v-if="taskDetail.tagCodes.includes('RISK_CUSTOMER')"
              >风险</span>
              <span
                class="order-tag"
                v-if="taskDetail.tagCodes.includes('SENSITIVE_CUSTOMER')"
              >敏感</span>
            </template>
          </div>
          <div class="car-info-item">
            <span>类型：</span>
            <span class="car-no">{{
              taskDetail.productCategoryName || "-"
            }}</span>
            <span
              class="car-no"
              style="margin-left: 8px"
            >{{
              taskDetail.isAccidentRescue === 1 ? "事故" : "非事故"
            }}</span>
          </div>
          <div class="car-info-item">
            <span>增值产品：</span>
            <span class="car-no">{{
              taskDetail.extraProduct ? extraProductStringList.join(",") : "-"
            }}</span>
          </div>
          <div class="car-info-item">
            <span>优惠信息：</span>
            <span class="car-no">{{ rightRemark }}</span>
          </div>
          <div class="car-info-item">
            <span>救援时间：</span>
            <span class="car-no">{{ taskDetail.appointmentTime || "" }}</span>
            <template
              v-if="
                taskDetail.appointmentTime &&
                  taskDetail.appointmentTime.includes('实时')
              "
            >
              <span class="divider">|</span>
              <span
                class="txt-btn"
                @click="editTime"
              >修改</span>
            </template>
          </div>
        </div>

        <!-- 地址信息 -->
        <div class="car-info-box card-box card-padding">
          <div class="card-title card-title-flex">
            <div>
              <span>地址信息</span>
              <!-- v-if="isStartStatus" -->
              <span
                class="map-btn"
                @click="showMapNavigation"
              >
                <van-icon name="guide-o" />
                导航到起点
              </span>
            </div>
            <span class="card-title-distance">
              <van-icon name="location" />
              <span
                v-if="distance"
              >距您约{{ (distance / 1000).toFixed(1) }}公里</span>
              <span
                style="color: #999999"
                v-else
              >正在计算...</span>
            </span>
          </div>
          <div class="address-box">
            <div class="address-item">
              <div class="address-round round-green" />
              <div>{{ taskDetail.contactAddress }}</div>
            </div>
            <div
              class="address-item address-destination"
              v-if="isTrailer"
            >
              <div class="address-round round-red" />
              <div v-if="taskDetail.destination">
                {{ taskDetail.destination }}
              </div>
              <div
                style="color: #ff8a59"
                v-else
              >
                未填写，请到达后和客户确认
              </div>
              <van-icon
                v-if="canEditDestination"
                @click="editDestination"
                name="edit"
              />
            </div>
          </div>
        </div>

        <!-- 备注 -->
        <div class="car-info-box card-box card-padding">
          <div class="card-title card-title-flex">
            <span>备注</span>
          </div>
          <div class="car-remark">
            {{ taskDetail.orderProviderRemark || "" }}
          </div>
        </div>

        <!-- 确认弹窗 -->
        <ConfirmDialog ref="confirmDialog" />

        <!-- 选择地址弹窗 -->
        <SelectLocation
          ref="selectLocation"
          @confirm="locationConfirm"
        />

        <SelectMapNavigation ref="selectMapNavigation" />

        <!-- 日期选择器弹出层 -->
        <van-popup
          v-model="showDatePicker"
          round
          position="bottom"
        >
          <van-datetime-picker
            type="datetime"
            :min-date="dateRange.minDate"
            :max-date="dateRange.maxDate"
            :formatter="dateFormatter"
            @confirm="onDateConfirm"
            @cancel="showDatePicker = false"
          />
        </van-popup>
      </div>
    </div>
    <div
      class="bottom-box"
      v-if="isTakeStatus || isStartStatus"
    >
      <!-- 底部滑动条 -->
      <ClickButton
        ref="clickButton"
        @sliderCompleted="sliderCompleted"
      >
        {{ isTakeStatus ? "点击已出发" : isStartStatus ? "点击已到达" : "" }}
      </ClickButton>
    </div>
    <!-- 联系坐席 -->
    <PhoneCall2 />
    <!-- 联系客户 -->
    <PhoneCall
      v-if="taskDetail.contactPhone"
      :phone="taskDetail.contactPhone"
      :task-no="taskDetail.taskNo"
      :task-status="taskDetail.taskStatus"
    />

    <!-- 长城预约时间修改 -->
    <AppointmentTimeAlertView
      :task-no="taskNo"
      ref="appointmentTimeAlertViewRef"
      @confirm="getTaskDetail"
    />

    <!-- 长城预约时间修改 -->
    <TipsDelayDialog
      ref="tipsDelayDialogRef"
    />

    <!-- 平安判断服务商能否预约 -->
    <DelayTipsDialog ref="delayTipsDialogRef" />

    <AppointmentCheckTipsDialog ref="appointmentCheckTipsDialogRef" />

    <ArrivePhotoUploadDialog
      ref="arrivePhotoUploadDialogRef"
      :order-no="orderNo"
      :task-no="taskNo"
      :use-trace-car="taskDetail.useTraceCar"
      :task-detail="taskDetail"
      :current-position="currentPosition"
      @uploaded="handleArrivePhotoUploaded"
    />

  </div>
</template>

<script>
import dayjs from 'dayjs';
import ClickButton from '@/components/clickButton.vue';
import ConfirmDialog from '@/components/confirmDialog.vue';
import PhoneCall from '../components/phoneCall.vue';
import PhoneCall2 from '../components/phoneCall2.vue';
import SelectLocation from '../components/selectLocation.vue';
import SelectMapNavigation from '../components/selectMapNavigation.vue';
import { TASK_STATUS_CODE, paicProductCode, generalProductCode } from '@/common/constant';
import { PRODUCT_CODE_TYPE } from '@/common/product-config';
import {
  getTaskDetail,
  getRightRemark,
  getMediaTemplate
} from '@/common/apiPaic.js';
import {
  callPhone,
  updateAppointment,
  checkCallPhone,
  workerSetOut,
  workerArrive,
  updateAppointmentCheck
} from '@/common/apiGeneral.js';
import { handleClipboard } from '@/common/clipboard';
import { mapActions } from 'vuex';
import getCurrentPositionMixin from '../mixins/getCurrentPositionMixin';
import AppointmentTimeAlertView from '../components/appointmentTimeAlertView.vue';
import AppointmentCheckTipsDialog from '../components/appointmentCheckTipsDialog.vue';
import TipsDelayDialog from '../components/tipsDelayDialog.vue';
import { Dialog } from 'vant';
import DelayTipsDialog from '@/components/delayTipsDialog.vue';
import ArrivePhotoUploadDialog from '../components/arrivePhotoUploadDialog.vue';
export default {
  name: 'GeneralOrderWaitService',
  mixins: [getCurrentPositionMixin],
  components: {
    ClickButton,
    ConfirmDialog,
    PhoneCall,
    PhoneCall2,
    SelectLocation,
    SelectMapNavigation,
    AppointmentTimeAlertView,
    AppointmentCheckTipsDialog,
    TipsDelayDialog,
    DelayTipsDialog,
    ArrivePhotoUploadDialog
  },
  data() {
    return {
      TASK_STATUS_CODE,
      productCodeType: PRODUCT_CODE_TYPE,
      orderNo: '',
      taskNo: '',
      taskDetail: {},
      rightRemark: '',
      extraProductStringList: [],
      showDatePicker: false,
      copyText: '',
      arrivePhotoSkipDistanceCheck: false,
      keywordStr:
        '4S店、4s店、汽车贸易、汽车销售、汽车服务、二手车、汽车维修、汽车城、名车、奔驰、宝马、奥迪、汽车城、机动车、比亚迪、雷克萨斯、汽车广场、汽车修理、保时捷、本田、丰田、沃尔沃'
    };
  },
  computed: {
    dateRange() {
      // 只能选择今天起，7天内的日期（含今天）
      const now = dayjs();
      const minDate = now.add(1, 'minute');

      let maxDate = now.add(6, 'day');
      maxDate = maxDate.set('hour', 23);
      maxDate = maxDate.set('minute', 59);
      maxDate = maxDate.set('second', 59);
      maxDate = maxDate.subtract(1, 'minute');

      return {
        minDate: new Date(minDate),
        maxDate: new Date(maxDate)
      };
    },
    // 是否待服务
    isTakeStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.take;
    },
    // 是否待到达
    isStartStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.start;
    },
    distance() {
      if (
        this.currentPosition &&
        this.currentPosition.latitude &&
        this.currentPosition.longitude &&
        this.taskDetail &&
        this.taskDetail.latitude &&
        this.taskDetail.longitude
      ) {
        // 返回 p1 到 p2 间的地面距离，单位：米
        const distance = AMap.GeometryUtil.distance(
          [this.currentPosition.longitude, this.currentPosition.latitude],
          [this.taskDetail.longitude, this.taskDetail.latitude]
        );
        return distance;
      }
      return false;
    },
    // 拖车
    isTrailer() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FL10000002].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    // 平安
    isPaic() {
      return (
        this.taskDetail &&
        [1].includes(
          this.taskDetail.isPaicOrder
        )
      );
    },
    // 搭电
    isJumpStart() {
      return (
        this.taskDetail &&
        [generalProductCode.categoryCode_FL10000006].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    showRemainderNotify() {
      return this.taskDetail.remainderCount > 0;
    },
    // 平安拖车订单 已接单
    showWorkerNotify() {
      const { contactAddress = '' } = this.taskDetail;
      const keywordArr = this.keywordStr.split('、');
      const hasKeyword = keywordArr.some((item) =>
        contactAddress.includes(item)
      );
      return (
        this.taskDetail.isPaicOrder === 1 &&
        this.isTrailer &&
        this.isTakeStatus &&
        hasKeyword
      );
    },
    canEditDestination() {
      return this.taskDetail && this.taskDetail.cooperativeOutlet !== 1;
    },
    // 是否显示至尊vip
    isShowZvVip() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_ZV')
      );
    },
    // 是否显示黑钻客户
    isShowBcCustomer() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_BC')
      );
    },
    // 至尊vip和重点保司
    isZvVipAndVipCompany() {
      return (
        this.taskDetail.vipCompany === '1' &&
        (this.isShowZvVip || this.isShowBcCustomer)
      );
    },
    isCCQC() {
      // 长城汽车
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'CCQC';
    },
    isShowOrderCompany() {
      return this.taskDetail &&
        (this.taskDetail.isPaicOrder === 1 || this.taskDetail.channelCompanyNo === 'PICC');
    },
    orderCompanyText() {
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'PICC' ? '人保' : '平安';
    },
    isPiccAppointmentCheckOrder() {
      return this.taskDetail &&
        this.taskDetail.channelCompanyNo === 'PICC';
    },
    isRoadRescueType() {
      // 道路救援、困境救援、事故救援 显示当前模块
      const { roadRescueType, distressRescueType, accidentRescueType } =
        this.productCodeType;
      return (
        this.taskDetail &&
        [
          ...roadRescueType,
          ...distressRescueType,
          ...accidentRescueType
        ].includes(this.taskDetail.categoryCode)
      );
    }
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
      this.getTaskDetail();
      this.getCurrentPosition();
    }
  },
  methods: {
    ...mapActions('orderGeneral', ['setTaskStatus']),
    async editTime() {
      // 长城，修改预约时间
      if (this.isCCQC) {
        const res = { appointmentTime: this.taskDetail.appointmentTime };
        this.$refs.appointmentTimeAlertViewRef.open(res);
        return;
      }
      if (this.taskDetail.isPaicOrder === 1 || this.isPiccAppointmentCheckOrder) {
        await this.handleUpdateAppointmentCheck({
          onPass: () => {
            if (this.taskDetail.isPaicOrder === 1) {
              this.falseAppointmentBooking();
              return;
            }
            this.showDatePicker = true;
          }
        });
        return;
      }
      this.showDatePicker = true;
    },
    async handleUpdateAppointmentCheck({ onPass }) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      try {
        const res = await updateAppointmentCheck({
          taskNo: this.taskNo
        });
        this.$toast.clear();
        if (res && res.code) {
          if (res.code === '7009') {
            this.$refs.delayTipsDialogRef.open({
              content: res.message || '到勘时效短，仍需预约请联系中保客服，经核实非真实预约将处罚',
              confirmCallback: () => {
              }
            });
            return;
          }
          if (res.code === '7016') {
            this.openAppointmentCheckTipsDialog(res.message || '请引导客户重新下单');
            return;
          }
          if (res.code === '7017') {
            this.openAppointmentTimeoutDialog(res.message || '已超时，此单无法预约');
            return;
          }
        }
        onPass && onPass();
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    falseAppointmentBooking() {
      if (this.taskDetail.appointmentTime.includes('实时')) {
        const that = this;
        Dialog.confirm({
          title: '提示',
          message: '<span style="color: red;">虚假打预约，将处以高额罚款，请确认是否预约</span>',
          confirmButtonText: '是',
          cancelButtonText: '否',
          allowHtml: true,
          confirmButtonColor: '#3399FF'
        })
          .then(() => {
            that.showDatePicker = true;
          })
          .catch(() => {
          });
      } else {
        this.showDatePicker = true;
      }
    },
    openAppointmentCheckTipsDialog(content) {
      this.$refs.appointmentCheckTipsDialogRef.open({
        content,
        warningText: '注意：修改预约需客户线上确认后才能生效',
        okCallback: () => {
          this.toCancelOrderPage();
        },
        insistCallback: () => {
          this.openInsistAppointmentDialog();
        }
      });
    },
    openAppointmentTimeoutDialog(content) {
      this.$refs.confirmDialog.open({
        title: '提示',
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: '好的',
        confirmText: content
      });
    },
    openInsistAppointmentDialog() {
      this.$refs.appointmentTimeAlertViewRef.open({
        appointmentTime: this.taskDetail.appointmentTime,
        needReason: false,
        dateRangeGetter: () => this.getInsistAppointmentDateRange()
      });
    },
    getInsistAppointmentDateRange() {
      const now = dayjs();
      return {
        minDate: now.add(1, 'hour').add(1, 'minute').toDate(),
        maxDate: now.add(7, 'day').subtract(1, 'minute').toDate()
      };
    },
    toCancelOrderPage() {
      this.$router.push({
        name: 'GeneralOrderCancelOrder',
        params: {
          fromPage: this.$route.name,
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      });
    },
    onDateConfirm(date) {
      this.showDatePicker = false;
      const res = dayjs(date).format('YYYY-MM-DD HH:mm');
      this.updateAppointment(res);
    },
    locationConfirm() {
      this.getTaskDetail();
    },
    dateFormatter(type, val) {
      switch (type) {
        case 'year':
          return val + '年';
        case 'month':
          return val + '月';
        case 'day':
          return val + '日';
        case 'hour':
          return val + '点';
        case 'minute':
          return val + '分';
        default:
          return val;
      }
    },
    showMapNavigation() {
      this.$refs.selectMapNavigation.open(
        this.taskDetail.contactAddress,
        this.taskDetail.longitude,
        this.taskDetail.latitude
      );
    },
    editDestination() {
      this.$refs.selectLocation.open(
        this.currentPosition,
        this.taskNo,
        this.taskDetail.taskStatus
      );
    },
    copy(e, txt) {
      handleClipboard(txt, e);
    },
    // 滑动到底
    async sliderCompleted() {
      // 检查是否拨打电话
      await this.checkCallPhone();
      // this.$refs.clickButton.reset();
    },
    // 页面跳转
    toPage() {
      let name = 'GeneralOrderWaitArrive';
      if (this.isTakeStatus) {
        name = 'GeneralOrderWaitArrive';
      } else if (this.isStartStatus) {
        name = 'GeneralOrderTaskExecution';
      }
      const router = {
        name,
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      };
      this.$router.replace(router);
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
          const extraProduct = this.taskDetail.extraProduct || [];
          this.extraProductStringList = extraProduct.map(
            (item) => `${item.name}(${Number(item.value)})`
          );
          this.getRightRemark();
          this.$route.meta.title = this.isTakeStatus ? '待服务' : '待到达现场';
          this.setTaskStatus(this.taskDetail.taskStatus);
          // 获取可复制的服务凭证信息
          this.getMediaTemplate();
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取影像模板
    async getMediaTemplate() {
      const res = await getMediaTemplate({
        orderNo: this.orderNo,
        templateType: 'mainTemplate',
        source: 4
      });
      if (res) {
        const data = res || [];
        const arr = [];
        for (const item of data) {
          if (item.secondary) {
            const arr2 = [];
            for (const item2 of item.secondary) {
              if (item2.requiredNum > 0) {
                arr2.push(item2.typeName);
              }
            }
            if (arr2.length > 0) {
              arr.push(`${item.primaryName}(${arr2.join('、')})`);
            }
          }
        }
        this.copyText = this.taskDetail.orderNo + '\n' + arr.join('、');
      }
    },
    async getRightRemark() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getRightRemark({
          orderNo: this.orderNo
        });
        this.rightRemark = data.resultValue;
      } catch (error) {
        console.log(error);
      }
    },
    async updateAppointment(appointmentTime) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const res = await updateAppointment({
          taskNo: this.taskNo,
          appointmentTime
        });
        if (res && res.code) {
          if (res.code === '7009') {
            this.$refs.delayTipsDialogRef.open({
              content: res.message || '到勘时效短，仍需预约请联系中保客服，经核实非真实预约将处罚',
              confirmCallback: () => {
              }
            });
            return;
          }
        }
        this.$toast('修改成功');
        this.getTaskDetail();
      } catch (error) {
        console.log(error);
      }
    },
    async checkCallPhone() {
      try {
        const data = await checkCallPhone({
          taskNo: this.taskDetail.taskNo,
          taskStatus: this.taskDetail.taskStatus
        });
        if (!data) {
          // const message = this.isTakeStatus ? '确认出发前需要先拨打客户电话与客户确认需求！' : '电话联系车主后才能到达现场！';
          // this.$dialog.confirm({
          //   title: '提示',
          //   message,
          //   confirmButtonColor: '#3399FF'
          // });
          // 未拨打电话则自动标记已拨打以跳过该校验
          this.callPhone();
        } else {
          // 状态流转
          this.statusChange();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async callPhone() {
      try {
        await callPhone({
          taskNo: this.taskNo,
          taskStatus: this.taskStatus
        });
        // 状态流转
        this.statusChange();
      } catch (error) {
        console.log(error);
      }
    },
    async statusChange(skipDistanceCheck = false, noLoading, ignoreArrivePhotoMock = false) {
      if (!this.currentPosition) {
        this.$toast('当前位置获取失败，请确认是否打开位置权限！');
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        if (
          process.env.NODE_ENV === 'development' &&
          this.isStartStatus &&
          !ignoreArrivePhotoMock &&
          this.$route.query.mockArrive7015 === '1'
        ) {
          if (!noLoading) {
            this.$toast.clear();
          }
          this.arrivePhotoSkipDistanceCheck = skipDistanceCheck;
          this.$refs.arrivePhotoUploadDialogRef.open({
            code: '7015',
            message: '模拟上传到达现场照片'
          });
          return;
        }

        const api = this.isTakeStatus ? workerSetOut : workerArrive;
        const res = await api({
          taskNo: this.taskDetail.taskNo,
          ...this.currentPosition,
          skipDistanceCheck
        });

        if (!noLoading) {
          this.$toast.clear();
        }

        console.log('res:', res);

        if (res && res.code) {
          if (String(res.code) === '7003') {
            // 距离超过500m
            await this.$dialog.confirm({
              title: '提示',
              message: res.message || '您距离报案地点似乎还有一段距离，是否确认已经到达现场？',
              confirmButtonColor: '#3399FF'
            });
            this.statusChange(true);
          } else if (String(res.code) === '7015') {
            this.arrivePhotoSkipDistanceCheck = skipDistanceCheck;
            this.$refs.arrivePhotoUploadDialogRef.open({
              ...res,
              skipDistanceCheck
            });
          }
        } else {
          // 平安搭电订单 变更状态为已出发和已到达时，弹窗提醒“严禁推销或更换电瓶，一经发现处以高额罚款”，倒计时三秒后才可手动关闭
          if (this.isPaic && this.isJumpStart) {
            this.$refs.tipsDelayDialogRef.open({
              confirmCallback: () => {
                this.toPage();
              }
            });
          } else {
            this.toPage();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleArrivePhotoUploaded() {
      this.statusChange(this.arrivePhotoSkipDistanceCheck, false, true);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-box {
  .van-notify {
    top: 46px;
  }
  .header-notify-box {
    position: sticky;
    top: 0;

    display: flex;
    align-items: center;

    padding: 8px 12px;

    letter-spacing: 0;

    color: #861314;
    background: #fbe5e5;

    font-family: PingFangSC-Medium;
    font-size: 12px;
    font-weight: 500;

    .img-icon {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .top-box {
    overflow-y: auto;

    height: calc(100vh - 72px - 46px);

    background: #f2f3f5;
  }
  .bottom-box {
    height: 72px;
  }
}
.flex-box {
  display: flex;
}
.content-box {
  padding-bottom: 32px;

  .car-info-box {
    padding: 13px 16px 15px;

    background: #ffffff;

    .vip-icon {
      width: 19px;
      height: 18px;
      margin-top: 2px;
      margin-left: 4px;
    }

    .zv-vip-icon {
      margin-left: 4px;
      margin-top: 2px;
      padding: 0 4px;
      text-align: center;
      letter-spacing: 0;
      color: #ffffff;
      border-radius: 4px;
      background: #f32222;
      font-family: PingFangSC-Regular;
      font-size: 10px;
      font-weight: 400;
      line-height: 18px;
      height: 18px;
      white-space: nowrap;
    }

    .paic-icon {
      width: 43px;
      height: 18px;
      margin-top: 2px;
      margin-left: 4px;
    }

    .cicp-icon {
      width: 43px;
      height: 18px;
      margin-top: 2px;
      margin-left: 4px;
    }

    .dispatch-icon {
      width: 24px;
      height: 18px;
      margin-top: 2px;
      margin-left: 4px;
    }
    .copy-btn {
      width: 32px;
      height: 18px;
      margin-left: 4px;
      padding: 2px 6px;

      text-align: center;
      white-space: nowrap;

      color: #3399ff;
      border: 1px solid #3399ff;
      border-radius: 100px;
      background: #eaf4ff;

      font-size: 10px;
      font-weight: 400;
      line-height: 18px;
    }

    .order-no-item {
      display: flex;
      align-items: baseline;
      justify-content: space-between;

      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;

      .order-no-item-left {
        display: flex;
        flex: 0 0 300px;

        .order-company {
          white-space: nowrap;
        }

        .car-no {
          &.color-red {
            color: #f32222;
          }

          &.order-no {
            flex: 0 0 150px;

            word-break: break-all;
          }

          &.order-svip {
            flex: 0 0 100px;

            word-break: break-all;
          }
        }
      }

      .order-polymerize {
        margin-left: 4px;
        padding: 1px 8px;

        text-align: center;
        white-space: nowrap;
        letter-spacing: -0.31px;

        color: #ffffff;
        border-radius: 9px 9px 9px 0px;
        background: #ff8a59;

        font-family: PingFangSC-Medium;
        font-size: 12px;
        font-weight: 500;
      }
    }

    .car-info-item {
      display: flex;

      letter-spacing: -0.38px;

      color: #646464;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      .order-tag {
        margin-left: 4px;
        padding: 0 4px;

        text-align: right;
        letter-spacing: -0.26px;

        color: #d36868;
        border-radius: 1px;
        background: #ffe7e7;

        font-family: PingFangSC-Regular;
        font-size: 10px;
        font-weight: 400;
      }

      .copy-btn {
        color: #3399ff;
      }

      .van-tag {
        margin-left: 8px;
        padding: 1px 4px;
      }

      & + .car-info-item {
        padding-top: 8px;
      }
      .carNo {
        padding: 0;
      }
      .car_red {
        color: #f32222;
      }

      .divider {
        padding: 0 5px 0 10px;

        color: #e3e3e3;
      }
      .txt-btn {
        padding: 0 5px;

        color: #3399ff;

        font-size: 10px;
      }
      span {
        &:first-child {
          flex: 0 0 74px;
        }
        & + span {
          color: #383838;
        }
        &.car-no {
          font-family: PingFangSC-Medium;
          font-weight: 500;
        }
      }
      .edit {
        margin: 2px 10px;

        color: #3399ff;
      }
    }
  }

  .card-box {
    margin: 12px 12px 0;

    border-radius: 8px;
    background: #ffffff;

    &.card-padding {
      padding: 16px;
    }

    ::v-deep .card-title,
    .card-title {
      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;

      &.card-title-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .card-title-info {
        display: flex;
        align-items: center;

        letter-spacing: -0.38px;

        color: #383838;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        .van-icon {
          margin-left: 8px;

          color: #999999;

          font-size: 16px;
        }
      }

      .card-title-distance {
        letter-spacing: -0.38px;

        color: #646464;

        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 21px;
      }

      .card-tips {
        letter-spacing: -0.38px;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        &.card-tips__red {
          color: #f32222;
        }
      }
      .card-tips__gary {
        color: #787878;

        font-size: 12px;
      }
      .card-tag {
        margin-left: 8px;
        padding: 1px 8px 2px;

        letter-spacing: -0.31px;

        border-radius: 2px;

        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;

        &.card-tag__red {
          color: #c78062;
          background: #fff0ea;
        }
      }
      .card-text-btn {
        text-align: right;
        letter-spacing: -0.38px;

        color: #3399ff;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
      }
    }

    .address-box {
      margin-top: 12px;
      padding: 16px;

      border-radius: 8px;
      background-color: #eff6f5;
      .address-item {
        display: flex;
        align-items: baseline;

        color: #383838;

        font-size: 14px;
        line-height: 21px;

        & + .address-item {
          margin-top: 12px;
        }

        .address-round {
          flex: 10px 0 0;

          width: 10px;
          height: 10px;
          margin-right: 8px;

          border-radius: 100%;
          &.round-green {
            background-color: #76c16d;
          }
          &.round-red {
            background-color: #ef9164;
          }
        }
        &.address-destination {
          color: #7a7f7f;
        }

        .van-icon {
          margin-left: 8px;

          font-size: 16px;
        }
      }
    }

    .car-remark {
      margin-top: 11px;

      letter-spacing: -0.38px;

      color: #646464;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;
    }

    .card-info {
      margin-top: 10px;

      color: #383838;

      font-size: 15px;
    }
    .card-tips__red {
      color: #f32222;
    }

    ::v-deep .van-checkbox {
      letter-spacing: -0.38px;

      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      .van-checkbox__icon {
        font-size: 16px;
        &.van-checkbox__icon--checked .van-icon {
          border-color: #3399ff;
          background-color: #3399ff;
        }
        .van-icon {
          border: 1px solid rgba(153, 153, 153, 1);
          border-radius: 4px;
        }
      }
    }

    .placeholder-box {
      margin-bottom: 24px;
    }

    .van-button {
      text-align: center;
      letter-spacing: -0.38px;

      color: #ffffff;
      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--info {
        border-color: #3399ff;
        background-color: #3399ff;
      }

      &.van-button--large {
        height: 39px;
      }
    }
  }

  .select-box {
    .select-item {
      padding: 5px 10px;

      text-align: center;
      letter-spacing: -0.38px;

      color: #646464;
      border-radius: 4px;
      background: #e1e7ed;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      &.active {
        color: #ffffff;
        background: #3399ff;
      }
    }
  }
  .collapse {
    border-bottom: 1px solid #e6e6e6;
    .isActive {
      color: #ff8a59;

      font-size: 12px;
    }
    ::v-deep .accidentValue {
      color: #3399ff;
    }
    ::v-deep .van-cell__right-icon {
      color: #3399ff;
    }
    ::v-deep .van-cell {
      padding: 10px 0;
    }
    ::v-deep .van-collapse-item__content {
      padding: 5px 0;
    }
  }
  .collapse:last-child {
    border-bottom: 0;
  }

  .textarea-box,
  ::v-deep .textarea-box {
    padding: 12px;

    letter-spacing: -0.38px;

    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 8px;
    background: #ffffff;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    ::v-deep .van-field__control {
      color: #383838;

      &::placeholder {
        color: #c8c8c8;
      }
    }
  }
}
.select-box {
  display: flex;
  flex-wrap: wrap;
  .select-item {
    min-width: 30px;
    margin: 0 10px 10px 0;
    padding: 5px 10px;

    text-align: center;
    letter-spacing: -0.38px;

    color: #646464;
    border-radius: 4px;
    background: #e1e7ed;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.active {
      color: #ffffff;
      background: #3399ff;
    }
  }
}
.card-title-sub {
  // font-weight: 500;
  padding: 10px 0 15px;

  color: #787878;
  border-bottom: 1px solid #e6e6e6;

  font-family: PingFangSC-Medium;
  font-size: 15px;
}

.map-btn {
  margin-left: 20px;
  padding: 2px 8px;

  color: #3399ff;
  border: 1px solid #3399ff;
  border-radius: 20px;

  font-size: 10px;
}
</style>
